/* eslint-disable react-hooks/exhaustive-deps */
import React, { FC, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { ROUTES } from "../../../utils/routes";
import Axios from "axios";
import { getAll } from "../../../utils/requests/dynamicReq";
import { paths } from "../../../utils/paths";
import { format } from "date-fns";

import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Col, Form, InputGroup, Row, Table } from "react-bootstrap";
import { useSelector } from "react-redux";
import { IStore } from "../../../interfaces/IStore";
import { IUser } from "../../../interfaces/IUser";

interface IItemShort {
  id: string;
  titulo: string;
  revista: any;
  usuarioPrestamo: any;
  anyo:any,
  fechaPrestamo: any
}

export const Biblioteca: FC = () => {
  const history = useHistory();
  const { staffId, isAdmin } = useSelector(({ user }: IStore) => user as IUser);

  const [isLoading, setIsLoading] = useState(false);
  const isMountedRef = useRef(false);
  const source = Axios.CancelToken.source();
  const { LIBROS, EJEMPLARES } = paths;

  const [libros, setLibros] = useState<IItemShort[]>([]);
  const [ejemplares, setEjemplares] = useState<IItemShort[]>([]);
  const [filteredItems, setFilteredItems] = useState<IItemShort[]>([]);
  const [search, setSearch] = useState("");
  const [filterDisponibilidad, setFilterDisponibilidad] =
    useState<string>("all");
  const [filterTipo, setFilterTipo] = useState<string>("all");
 const [sortConfig, setSortConfig] = useState<{
   key: keyof IItemShort | null;
   direction: "asc" | "desc";
 } | null>(null);

  useEffect(() => {
    setIsLoading(true);
    isMountedRef.current = true;
    try {
      isMountedRef.current && loadData();
    } catch (error) {
      console.log("Error during data load:", error);
    }
    return () => {
      isMountedRef.current = false;
      source.cancel();
    };
  }, []);

  const loadData = async () => {
    try {
      const librosResponse = await getAll(LIBROS, source);
      const ejemplaresResponse = await getAll(EJEMPLARES, source);
      if (isMountedRef.current) {
        const formattedLibros = formatItems(librosResponse);
        const formattedEjemplares = formatItems(ejemplaresResponse);
        setLibros(formattedLibros);
        setEjemplares(formattedEjemplares);
        setFilteredItems([...formattedLibros, ...formattedEjemplares]);
      }
      setIsLoading(false);
    } catch (error) {
      console.log("HTTP call cancelled or failed:", error);
    }
  };

const formatItems = (items: any[]): IItemShort[] =>
  items.map(
    ({ id, titulo, anyo, fechaPrestamo, revista, usuarioPrestamo }) => ({
      id: id || "", // Si no hay `id`, asigna un string vacío
      titulo,
      anyo,
      fechaPrestamo: fechaPrestamo
        ? format(new Date(fechaPrestamo), "dd/MM/yyyy")
        : "N/A",
      revista: revista || null, // Si no hay `revista`, asigna `null`
      usuarioPrestamo: usuarioPrestamo || null, // Si no hay `usuarioPrestamo`, asigna `null`
    })
  );

  const handleFilters = () => {
    const combinedItems = [...libros, ...ejemplares];
    let result = combinedItems;

    if (filterDisponibilidad !== "all") {
      const isAvailable = filterDisponibilidad === "available";
      result = result.filter(
        (item) =>
          (isAvailable && !item.usuarioPrestamo) ||
          (!isAvailable && item.usuarioPrestamo)
      );
    }

    if (filterTipo !== "all") {
      const isEjemplar = filterTipo === "ejemplar";
      result = result.filter(
        (item) => (isEjemplar && item.revista) || (!isEjemplar && !item.revista)
      );
    }

    if (search.trim() !== "") {
      result = result.filter((item) =>
        item.titulo.toLowerCase().includes(search.toLowerCase())
      );
    }

    setFilteredItems(result);
  };

  useEffect(() => {
    handleFilters();
  }, [search, filterDisponibilidad, filterTipo, libros, ejemplares]);

const sortByColumn = (key: keyof IItemShort) => {
  let direction: "asc" | "desc" = "desc";
  if (sortConfig?.key === key && sortConfig.direction === "desc") {
    direction = "asc";
  }

  setSortConfig({ key, direction });

  // Ordenar los datos originales antes de aplicar filtros
  const sortedItems = [...libros, ...ejemplares].sort((a, b) => {
    if (key === "fechaPrestamo") {
      const dateA =
        a.fechaPrestamo !== "N/A"
          ? new Date(a.fechaPrestamo.split("/").reverse().join("-"))
          : new Date(0);
      const dateB =
        b.fechaPrestamo !== "N/A"
          ? new Date(b.fechaPrestamo.split("/").reverse().join("-"))
          : new Date(0);

      return direction === "asc"
        ? dateA.getTime() - dateB.getTime()
        : dateB.getTime() - dateA.getTime();
    }

    if (a[key] < b[key]) return direction === "asc" ? -1 : 1;
    if (a[key] > b[key]) return direction === "asc" ? 1 : -1;
    return 0;
  });

  // Aplicar los filtros después de ordenar
  applyFilters(sortedItems);
};
const applyFilters = (items: IItemShort[]) => {
  let result = items;

  if (filterDisponibilidad !== "all") {
    const isAvailable = filterDisponibilidad === "available";
    result = result.filter(
      (item) =>
        (isAvailable && !item.usuarioPrestamo) ||
        (!isAvailable && item.usuarioPrestamo)
    );
  }

  if (filterTipo !== "all") {
    const isEjemplar = filterTipo === "ejemplar";
    result = result.filter(
      (item) => (isEjemplar && item.revista) || (!isEjemplar && !item.revista)
    );
  }

  if (search.trim() !== "") {
    result = result.filter((item) =>
      item.titulo.toLowerCase().includes(search.toLowerCase())
    );
  }

  setFilteredItems(result);
};

const columnHeaders: Partial<Record<keyof IItemShort, string>> = {
  titulo: "TÍTULO",
  anyo: "AÑO",
  fechaPrestamo: "Fecha de préstamo",
};
useEffect(() => {
  applyFilters([...libros, ...ejemplares]);
}, [search, filterDisponibilidad, filterTipo, libros, ejemplares]);
  return (
    <div className="container-fluid p-4">
      <div className="row">
        <div className="col-12 d-flex justify-content-between">
          <h3>Biblioteca</h3>
          <div>
            {isAdmin && (
              <button
                className="baseBtn"
                onClick={() => history.push(`${ROUTES.Libros.create}`)}
              >
                + Añadir Libro
              </button>
            )}
            {isAdmin && (
              <button
                className="baseBtn ml-10"
                onClick={() => history.push(`${ROUTES.Ejemplares.create}`)}
              >
                + Añadir Ejemplar
              </button>
            )}
          </div>
        </div>
      </div>
      <div className="row mt-4">
        <Row className="w-100">
          <Col md={4}>
            <InputGroup className="shadow">
              <InputGroup.Prepend>
                <InputGroup.Text className="inputGroup">
                  <FontAwesomeIcon color="#0073B5" icon={faSearch} />
                </InputGroup.Text>
              </InputGroup.Prepend>
              <Form.Control
                type="text"
                placeholder="Buscar..."
                className="form-control"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </InputGroup>
          </Col>
          <Col md={4}>
            <Form.Group>
              <Form.Control
                as="select"
                value={filterDisponibilidad}
                onChange={(e) => setFilterDisponibilidad(e.target.value)}
              >
                <option value="all">Todos</option>
                <option value="available">Disponible</option>
                <option value="notAvailable">No disponible</option>
              </Form.Control>
            </Form.Group>
          </Col>
          <Col md={4}>
            <Form.Group>
              <Form.Control
                as="select"
                value={filterTipo}
                onChange={(e) => setFilterTipo(e.target.value)}
              >
                <option value="all">Todos</option>
                <option value="libro">Libros</option>
                <option value="ejemplar">Ejemplares</option>
              </Form.Control>
            </Form.Group>
          </Col>
        </Row>
      </div>
      <div className="row">
        <div className="col-12">
          <Table striped bordered hover>
            <thead>
              <tr>
                {Object.keys(columnHeaders).map((col) => (
                  <th
                    key={col}
                    onClick={() => sortByColumn(col as keyof IItemShort)} // 👈 Corrección
                    style={{ cursor: "pointer" }}
                  >
                    {columnHeaders[col as keyof IItemShort]}{" "}
                    {sortConfig?.key === col
                      ? sortConfig.direction === "asc"
                        ? "▲"
                        : "▼"
                      : ""}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filteredItems.length > 0 ? (
                filteredItems.map(
                  ({ id, titulo, anyo, fechaPrestamo, revista }) => {
                    const path =
                      revista !== null
                        ? `${paths.EJEMPLARES}/${id}`
                        : `${paths.LIBROS}/${id}`;

                    return (
                      <tr key={id} onClick={() => history.push(path)}>
                        <td>{titulo}</td>
                        <td>{anyo}</td>
                        <td>{fechaPrestamo}</td>
                      </tr>
                    );
                  }
                )
              ) : (
                <tr>
                  <td colSpan={6} className="text-center">
                    No hay nada para mostrar
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
          {isLoading && (
            <div className="d-flex justify-content-center">
              <div className="spinner-border mt-5" role="status" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
